import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Btn } from "./ui";
import { Reveal } from "./useReveal";
import { LINKS } from "./data";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1526948531399-320e7e40f0ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

const POINTS = [
  "Licensed real estate & mortgage broker",
  "Over 25 years of industry experience",
  "Deep local knowledge across Southern California",
  "Personalized guidance from first call to closing",
];

export const AboutSection = () => (
  <section id="about" className="py-16 lg:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <img
            src={ABOUT_IMG}
            alt="John Pagani and the Wallstreet Realty team"
            className="w-full h-[300px] lg:h-[440px] object-cover rounded-[20px] shadow-lg"
            loading="lazy"
          />
        </Reveal>
        <Reveal delay={80}>
          <p className="text-[#C9A961] font-heading font-bold uppercase tracking-[0.18em] text-xs mb-3">
            A Legacy Built on Trust
          </p>
          <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl leading-[1.1] text-[#2D2D37]">
            Guided by Experience You Can Rely On
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#2D2D37]/70">
            Wallstreet Realty is a Southern California real estate and mortgage brokerage led by
            <span className="font-semibold text-[#254369]"> John Pagani</span>, a licensed real estate
            and mortgage broker with over 25 years of experience. Our team brings deep local
            knowledge to every transaction.
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-[#2D2D37]/65">
            We understand that buying or selling a home is more than a transaction. It's a
            life-changing decision. That's why we prioritize your best interests, providing
            personalized attention and expert guidance from the first conversation to closing day.
          </p>
          <ul className="mt-6 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-[15px] text-[#2D2D37]/80">
                <CheckCircle2 size={20} className="text-[#C9A961] shrink-0 mt-0.5" /> {p}
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap gap-3">
            <Btn href={LINKS.idx} variant="primary" testid="about-search-homes">Search Homes</Btn>
            <Btn href={LINKS.sellers} variant="outline" testid="about-home-value">Get My Home Value</Btn>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
